export default __webpack_public_path__ + "219343bc9ee3e444131bf7d2c6a9f7b4.png";